export enum STEP_NAMES {
    JOIN_STEP = 'JOIN_STEP',
    PERSONAL_STEP = 'PERSONAL_STEP',
    SECURITY_STEP = 'SECURITY_STEP',
    ADDRESS_STEP = 'ADDRESS_STEP',
    PREFERENCES_STEP = 'PREFERENCES_STEP',

    MEMBERSHIP_STEP = 'MEMBERSHIP_STEP',
    PIN_STEP = 'PIN_STEP',
    NO_PIN_STEP = 'NO_PIN_STEP',
    PASSWORD_CHANGE_STEP = 'PASSWORD_CHANGE_STEP',
    PASSWORD_AND_EMAIL_CHANGE_STEP = 'PASSWORD_AND_EMAIL_CHANGE_STEP',
    TERMS_UPDATE_STEP = 'TERMS_UPDATE_STEP',
    USER_DETAILS_STEP = 'USER_DETAILS_STEP',
    SECRETS_STEP = 'SECRETS_STEP',
    UPDATE_PREFERENCES_STEP = 'UPDATE_PREFERENCES_STEP',

    PERSONAL_RETAIL_STEP = 'PERSONAL_RETAIL_STEP',
    ADDRESS_RETAIL_STEP = 'ADDRESS_RETAIL_STEP',
    PIN_RETAIL_STEP = 'PIN_RETAIL_STEP',
    PASSWORD_RETAIL_STEP = 'PASSWORD_RETAIL_STEP',
    PREFERENCES_RETAIL_STEP = 'PREFERENCES_RETAIL_STEP',

    RESET_PASSWORD_RETAIL_UPGRADE_STEP = 'RESET_PASSWORD_RETAIL_UPGRADE_STEP',
    LOGIN_RETAIL_UPGRADE_STEP = 'LOGIN_RETAIL_UPGRADE_STEP',
    PIN_RETAIL_UPGRADE_STEP = 'PIN_RETAIL_UPGRADE_STEP',
    ADDRESS_RETAIL_UPGRADE_STEP = 'ADDRESS_RETAIL_UPGRADE_STEP',
    PREFERENCES_RETAIL_UPGRADE_STEP = 'PREFERENCES_RETAIL_UPGRADE_STEP',

    LOGIN_SLOT_UPGRADE_STEP = 'LOGIN_SLOT_UPGRADE_STEP',
    PREFERENCES_SLOT_UPGRADE_STEP = 'PREFERENCES_SLOT_UPGRADE_STEP',
}

export enum actionTypes {
    SET_CONFIG = 'SET_CONFIG',
    SET_IS_UPGRADE = 'SET_IS_UPGRADE',
    SET_ATTEMPT_ID = 'SET_ATTEMPT_ID',
    SET_IS_DESTROYED = 'SET_IS_DESTROYED',
    SET_UPGRADE_DATA = 'SET_UPGRADE_DATA',
    SET_RETAIL_REG_DATA = 'SET_RETAIL_REG_DATA',
    SET_RETAIL_UPGRADE_DATA = 'SET_RETAIL_UPGRADE_DATA',
    SET_SLOT_UPGRADE_DATA = 'SET_SLOT_UPGRADE_DATA',
    SET_INITIAL_STATE = 'SET_INITIAL_STATE',
    SET_IS_REGISTERED = 'SET_IS_REGISTERED',
    SET_LAST_FIELD_NAME = 'SER_LAST_FIELD_NAME',
    SET_NEXT_STEP_INDEX = 'SET_NEXT_STEP_INDEX',
    SET_IS_SHOW_RECAPTCHA = 'SET_IS_SHOW_RECAPTCHA',
    SET_IS_SUCCESS_RETAIL_REG = 'SET_IS_SUCCESS_RETAIL_REG',
    SET_FORGOT_PIN_DATA = 'SET_FORGOT_PIN_DATA',
    SET_REGISTRATION_DATA = 'SET_REGISTRATION_DATA',
    SET_BUYAPOWA_DATA = 'SET_BUYAPOWA_DATA',
    RESET_FORGOT_PIN_DATA = 'RESET_FORGOT_PIN_DATA',
    SET_ERROR_REGISTRATION = 'SET_ERROR_REGISTRATION',
    SET_IS_SHOW_CLOSE_POPUP = 'SET_IS_SHOW_CLOSE_POPUP',
    SET_IS_MANUALLY_ADDRESS = 'SET_IS_MANUALLY_ADDRESS',
    SET_IS_LOADING_SEND_FORM = 'SET_IS_LOADING_SEND_FORM',
    SET_UPGRADE_INITIAL_STATE = 'SET_UPGRADE_INITIAL_STATE',
    SET_FORCE_TO_CHANGE_EMAIL = 'SET_FORCE_TO_CHANGE_EMAIL',
    SET_OCCUPATION_SUGGESTIONS = 'SET_OCCUPATION_SUGGESTIONS',
    SET_REGISTRATION_NAME_STEP = 'SET_REGISTRATION_NAME_STEP',
    SET_ADDITIONAL_UPGRADE_DATA = 'SET_ADDITIONAL_UPGRADE_DATA',
    SET_ADDITIONAL_RETAIL_UPGRADE_DATA = 'SET_ADDITIONAL_RETAIL_UPGRADE_DATA',
    SET_IS_REGISTRATION_IN_PROCESS = 'SET_IS_REGISTRATION_IN_PROCESS',
    SET_IS_SHOW_POPUP_ALREADY_MEMBER = 'SET_IS_SHOW_POPUP_ALREADY_MEMBER',
    SET_REGISTRATION_RETAIL_WRAPPER_TYPE = 'SET_REGISTRATION_RETAIL_WRAPPER_TYPE',
    SET_BUSINESS_PHASES = 'SET_BUSINESS_PHASES',
}

export const DEFAULT_TERMS_DATA = {
    url: '',
    version: ''
};

export const DEFAULT_ERROR_REG_DATA = {
    isShow: false,
    texts: [],
    isShowGoToUpgradeButton: false,
    isShowLoginButton: false,
    isShowReCaptcha: false,
    afterReCaptchaAction: null,
    reCaptchaTitleTKey: '',
    reCaptchaOperation: '',
    isShowLogo: false
};

export const DEFAULT_ADDITIONAL_UPGRADE_DATA = {
    phase: '',
    userName: '',
    isConfirmedTerms: false,
    isEditAddress: false,
    isIdvNeeded: false,
    isWelcomeUser: false,
    isForgotPinBlock: false,
    isErrorStepFromSecretsQuestionStep: false,
    termsData: DEFAULT_TERMS_DATA
};

export const DEFAULT_ADDITIONAL_RETAIL_UPGRADE_DATA = {
    dateOfBirth: ''
};

export enum LAYOUT_STYLE {
    wizard = 'registration-wizard',
    multiColumn = 'registration-multi-column'
}

export enum REGISTRATION_TEMPLATES {
    default = 'default',
    upgrade = 'upgrade',
    retailReg = 'retail_registration',
    retailUpgrade = 'retail_upgrade',
    slotReg = 'slot_registration',
    slotUpgrade = 'slot_upgrade',
    defaultWithPin = 'default_with_pin',
}

export enum ONLINE_REG_BUSINESS_PHASES {
    online = 'online',
    multichannel = 'multichannel',
}
